import React from 'react';
import { Quote, Star } from 'lucide-react';
const testimonials = [{
  quote: 'En menos de 6 meses mi hijo pasó del nivel Recreational a un club ECNL. Las "5 métricas invisibles" cambiaron por completo la forma en que entrena. Por fin un scout se fijó en ÉL, no en el marcador.',
  name: 'Carlos Méndez',
  location: 'Houston, TX',
  initials: 'CM',
  image: 'https://cdn.magicpatterns.com/uploads/aTMdqtM51mBo5WSrEHbWx2/joven1.jpg'
}, {
  quote: 'Estaba a punto de gastar $4,000 en una academia que solo quería mi mensualidad. Este mapa me ahorró ese dinero y mi hija ya está en el radar de dos colleges. El Highlight Reel de 60 segundos fue clave.',
  name: 'Lucía Ramírez',
  location: 'Miami, FL',
  initials: 'LR',
  image: 'https://cdn.magicpatterns.com/uploads/iUSWf8kMoxkib1CL9MkwsA/joven4.jpg'
}, {
  quote: 'Por primera vez entendí qué buscan realmente los scouts. Dejé de presionar a mi hijo con goles y empezamos a trabajar el "Scanning". El cambio en su juego fue inmediato y notable.',
  name: 'Jorge Castillo',
  location: 'Los Angeles, CA',
  initials: 'JC',
  image: 'https://cdn.magicpatterns.com/uploads/4FfhnFekYML6zLmoaGqqXB/joven_3.jpg'
}, {
  quote: 'El Scorecard de Auditoría me abrió los ojos. Ahora veo los partidos de mi hijo como un profesional y detecto exactamente qué tiene que mejorar. Vale mil veces lo que pagué.',
  name: 'María Fernández',
  location: 'Chicago, IL',
  initials: 'MF',
  image: 'https://cdn.magicpatterns.com/uploads/juofxdHxPD6adp7qgBibDq/maria_fernandez.webp'
}, {
  quote: 'Las plantillas de Networking Pro funcionan. Contacté a un Director Técnico de un club Premier y me respondió en dos días. Mi hijo ya tiene fecha de tryout.',
  name: 'Roberto Salazar',
  location: 'Dallas, TX',
  initials: 'RS',
  image: 'https://cdn.magicpatterns.com/uploads/7DqbLbdUeWGhP9pkR67wAu/joven2.jpg'
}, {
  quote: 'Soy un papá que trabaja doble turno y no tenía tiempo de investigar todo esto. El método me dio el camino exacto, paso a paso. Lo mejor que he invertido en la carrera de mi hijo.',
  name: 'Diego Morales',
  location: 'Phoenix, AZ',
  initials: 'DM'
}, {
  quote: 'Mi hija siempre fue talentosa pero invisible para los clubes grandes. Seguimos la Ruta Crítica y este año la invitaron a un equipo MLS Next. Gracias por darnos el mapa.',
  name: 'Ana Gutiérrez',
  location: 'Atlanta, GA',
  initials: 'AG',
  image: 'https://cdn.magicpatterns.com/uploads/nNNYqm1WbJJY4rBFC4gSJ2/joven5.jpg'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-navy py-24 px-4 relative overflow-hidden" data-id="element-158">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-cyan/5 blur-[140px] rounded-full pointer-events-none" data-id="element-159" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-160">
        <div className="text-center mb-16" data-id="element-161">
          <h2 className="text-3xl md:text-5xl font-headline font-bold text-white uppercase mb-4" data-id="element-162">
            Padres Que Ya Tomaron el Mapa
          </h2>
          <p className="text-xl text-cyan font-medium" data-id="element-163">
            Resultados reales de familias como la tuya.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-164">
          {testimonials.map((t, index) => <div key={index} className="bg-navy-light border border-white/5 p-8 rounded-xl relative flex flex-col" data-id="element-165">
              <Quote className="w-10 h-10 text-gold/30 mb-4" data-id="element-166" />

              <div className="flex text-gold mb-4" data-id="element-167">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-168" />)}
              </div>

              <p className="text-gray-300 text-lg leading-relaxed italic mb-8 flex-grow" data-id="element-169">
                "{t.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto pt-6 border-t border-white/10" data-id="element-170">
                {t.image ? <img src={t.image} alt={`Hijo/a de ${t.name}`} className="w-12 h-12 rounded-full object-cover border border-gold/30 flex-shrink-0" data-id="element-171" /> : <div className="w-12 h-12 rounded-full bg-gold/10 border border-gold/30 flex items-center justify-center flex-shrink-0" data-id="element-172">
                    <span className="text-gold font-headline font-bold text-lg" data-id="element-173">
                      {t.initials}
                    </span>
                  </div>}
                <div data-id="element-174">
                  <p className="text-white font-bold font-headline text-lg leading-none" data-id="element-175">
                    {t.name}
                  </p>
                  <p className="text-muted text-sm mt-1" data-id="element-176">{t.location}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}